import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIconSecondary, icons } from 'smartsuite-ui';
import LandingPagePanelSelector from './LandingPagePanelSelector';
import { useModal } from '../shared/hooks/dashboardHooks';
import { getGridStyles } from '../viewDashboards/dashboardUtils';
import { useLabelContext } from '../shared/hooks/labelContext';
import DashboardContext from '../shared/hooks/dashboardContext';

export default function EmptyLandingPagePanel(props) {
    const { dashboardLabels } = useLabelContext();
    const { canModifyLandingPage } = useContext(DashboardContext);
    const [isModalVisible, closeModal, showModal] = useModal();

    if (!canModifyLandingPage) {
        return null;
    }

    return (
        <div
            className={props.panelClassName}
            style={getGridStyles(props.panelLayout.position)}
        >
            <div className="landing-page-widget landing-page-widget--empty">
                <ButtonWithIconSecondary
                    iconClass={icons.plus}
                    onClick={() => {
                        showModal();
                    }}
                />
            </div>
            {isModalVisible && (
                <LandingPagePanelSelector
                    closeModal={() => {
                        closeModal();
                    }}
                    modalHeader={dashboardLabels.addWidget}
                    onSave={(panel) => {
                        props.handleAdd(panel);
                    }}
                    panelIndex={props.panelIndex}
                />
            )}
        </div>
    );
}

EmptyLandingPagePanel.propTypes = {
    handleAdd: PropTypes.func.isRequired,
    panelClassName: PropTypes.string.isRequired,
    panelIndex: PropTypes.number.isRequired,
    panelLayout: PropTypes.instanceOf(Object).isRequired,
};
